module.exports = __webpack_public_path__ + "static/home-banner-ae85195d6a21675c58f46ff62d79bf69.png";